var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.5 19.5",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.5,9.75c0,.41-.34.75-.75.75H3.75c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h8c.41,0,.75.34.75.75ZM7.75,12H3.75c-.41,0-.75.34-.75.75s.34.75.75.75h4c.41,0,.75-.34.75-.75s-.34-.75-.75-.75ZM11.75,6H3.75c-.41,0-.75.34-.75.75s.34.75.75.75h8c.41,0,.75-.34.75-.75s-.34-.75-.75-.75ZM15.5,3.25v14c0,1.24-1.01,2.25-2.25,2.25H2.25c-1.24,0-2.25-1.01-2.25-2.25V3.25C0,2.01,1.01,1,2.25,1h.75v-.25c0-.41.34-.75.75-.75s.75.34.75.75v.25h2.5v-.25c0-.41.34-.75.75-.75s.75.34.75.75v.25h2.5v-.25c0-.41.34-.75.75-.75s.75.34.75.75v.25h.75c1.24,0,2.25,1.01,2.25,2.25ZM14,3.25c0-.41-.34-.75-.75-.75h-.75v.25c0,.41-.34.75-.75.75s-.75-.34-.75-.75v-.25h-2.5v.25c0,.41-.34.75-.75.75s-.75-.34-.75-.75v-.25h-2.5v.25c0,.41-.34.75-.75.75s-.75-.34-.75-.75v-.25h-.75c-.41,0-.75.34-.75.75v14c0,.41.34.75.75.75h11c.41,0,.75-.34.75-.75V3.25Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notes.a9ed2286c28cc1a1c81bc65cf907a876.svg";